<template xmlns="http://www.w3.org/1999/html">
<div style="text-align:center">
  <div class="print-table-wrapper" id="printContent" ref="printContent" >
    <div style="text-align: center;">
      <h1 style="color: red;font-family: fangzheng_GBK;font-weight:500; font-size: 48px;margin-bottom:10px">
        {{ topTitle }}
      </h1>
      <div
						style="border-bottom: 4px solid rgb(255,0,0,1 );display: flex;margin-top: 10px;"
					></div>
          <div
						style="border-bottom: 1px solid rgb(255,0,0,1 );display: flex;margin-top: 4px"
					></div>
      
      <h2 style="margin-top: 30px; margin-bottom: 30px;font-family: fangzhengxiaobiaosong;font-weight:normal; font-size: 30px;color:black;">
        {{ tableTitle }}会议议程
      </h2>
    
      <h3 style="margin-top: 5px; margin-bottom: 20px;font-weight:normal; font-size: 21px;color:black;font-family: 楷体">
        {{ this.detail.conferNum }}
      </h3>
    </div>
    <div>
      <table
        style="
          overflow: hidden;
          color: black;
          box-sizing: border-box;
        "
        cellspacing="0"
        cellpadding="0"
      >
        <tbody>
          <tr>
            <th
              colspan="1"
              style="
                white-space: nowrap;
                border-top: 1px solid black;
                vertical-align: middle;
                width: 100px;
                text-align: center;
                box-sizing: border-box;
                border-left: 1px solid black;
                border-right: 1px solid black;
                padding: 12px;
                font-family:SimHei;
                font-size: 20px;
                font-weight:normal;
              "
            >
              会议时间
            </th>
            <td
              colspan="5"
              style="
                border-top: 1px solid black;
                vertical-align: middle;
                width: 450px;
                box-sizing: border-box;
                border-right: 1px solid black;
                padding: 12px;
                text-align: left;
                font-family: 'fangsong_GB2312';
                font-size: 20px;
              "
            >
              {{ timeStr }}
            </td>
          </tr>
          <tr>
            <th
              colspan="1"
              style="
                white-space: nowrap;
                border-top: 1px solid black;
                border-left: 1px solid black;
                border-right: 1px solid black;
                vertical-align: middle;
                width: 100px;
                text-align: center;
                box-sizing: border-box;
                padding: 12px;
                font-family:SimHei;
                font-size: 20px;
                font-weight:normal;
              "
            >
              会议地点
            </th>
            <td
              colspan="5"
              style="
                border-top: 1px solid black;
                vertical-align: middle;
                border-right: 1px solid black;
                padding: 12px;
                text-align: left;
                font-family: 'fangsong_GB2312';
                 font-size: 20px;
              "
            >
              {{ detail.room }}
            </td>
          </tr>
          <tr>
            <th
              colspan="1"
              style="
                white-space: nowrap;
                border-top: 1px solid black;
                border-left: 1px solid black;
                border-right: 1px solid black;
                vertical-align: middle;
                width: 100px;
                text-align: center;
                box-sizing: border-box;
                padding: 12px;
                font-family:SimHei;
                font-size: 20px;
                font-weight:normal;
              "
            >
              出席人
            </th>
            <td
              colspan="2"
              style="
              width:240px;
                border-top: 1px solid black;
                vertical-align: middle;
                padding: 12px;
                text-align: left;
                font-family: 'fangsong_GB2312';
                 font-size: 20px;
              "
            >
              {{ joinWorkPeople }}
            </td>
            <th
              colspan="1"
              style="
                white-space: nowrap;
                border-top: 1px solid black;
                border-left: 1px solid black;
                border-right: 1px solid black;
                vertical-align: middle;
                width: 100px;
                text-align: center;
                box-sizing: border-box;
                padding: 12px;
                font-family:SimHei;
                font-size: 20px;
                font-weight:normal;
              "
            >
              列席人
            </th>
            <td
              colspan="2"
              style="
                border-top: 1px solid black;
                vertical-align: middle;
                border-right: 1px solid black;
                padding: 12px;
                text-align: left;
                font-family: 'fangsong_GB2312';
                 font-size: 20px;
              "
            >{{ detail.attendWorkName }}</td>
          </tr>
          <tr>
            <th
              colspan="1"
              style="
                white-space: nowrap;
                overflow: hidden;
                vertical-align: middle;
                width: 100px;
                text-align: center;
                box-sizing: border-box;
                padding: 12px;
                font-size: 20px;
                border-left: 1px solid black;
                border-right: 1px solid black;
                border-top: 1px solid black;
                font-family:SimHei;
                font-weight:normal;
              "
            >
              序号
            </th>
            <th
              colspan="2"
              style="
                white-space: nowrap;
                overflow: hidden;
                vertical-align: middle;
                width: 200px;
                text-align: center;
                box-sizing: border-box;
                padding: 12px;
                font-size: 20px;
                border-right: 1px solid black;
                border-top: 1px solid black;
                font-family:SimHei;
                font-weight:normal;
              "
            >
              会议研究事项
            </th>
            <th
              colspan="1"
              style="
                white-space: nowrap;
                overflow: hidden;
                vertical-align: middle;
                width: 100px;
                text-align: center;
                box-sizing: border-box;
                border-right: 1px solid black;
                padding: 12px;
                font-size: 20px;
                border-top: 1px solid black;
                font-family:SimHei;
                font-weight:normal;
              "
            >
              汇报部门
            </th>
            <th
              colspan="1"
              style="
                white-space: nowrap;
                overflow: hidden;
                vertical-align: middle;
                width: 100px;
                text-align: center;
                box-sizing: border-box;
                border-right: 1px solid black;
                padding: 12px;
                font-size: 20px;
                border-top: 1px solid black;
                font-family:SimHei;
                font-weight:normal;
              "
            >
              汇报人
            </th>

            <th
              colspan="1"
              style="
                white-space: nowrap;
                overflow: hidden;
                vertical-align: middle;
                width: 150px;
                text-align: center;
                box-sizing: border-box;
                border-right: 1px solid black;
                padding: 12px;
                font-size: 20px;
                border-top: 1px solid black;
                font-family:SimHei;
                font-weight:normal;
              "
            >
              参会部门
            </th>
          </tr>
          <template v-for="(item, index) in detail.agendaList">
            <tr v-if="index == 0" :key="index">
              <!-- 序号 -->
              <!-- 这里原来要合并的 -->
              <!-- :rowspan="detail.agendaList.length" -->
              <td
                style="
                  border: 1px solid black;
                  vertical-align: middle;
                  width: 100px;
                  text-align: center;
                  box-sizing: border-box;
                  padding: 12px;
                  font-family:SimHei;
                  font-size: 20px;
                "
              >
                <!-- <strong style="font-size: 28px;">
                  {{ typeStr }}
                </strong> -->
                {{ index + 1 }}
              </td>
              <!-- 会议研究事项 -->
              <td
                colspan="2"
                style="
                  border-top: 1px solid black;
                  border-right: 1px solid black;
                  padding: 12px;
                  width: 200px;
                  font-family: 'fangsong_GB2312';
                  font-size: 20px;
                  text-align:left;
                "
                :style="{
                  borderBottom:
                    index == detail.agendaList.length - 1
                      ? '1px solid black'
                      : '',
                }"
              >
                {{ item.title }}
              </td>
              <!-- 汇报部门 -->
              <td
                style="
                  border-top: 1px solid black;
                  border-right: 1px solid black;
                  padding: 12px;
                  text-align: left;
                  width: 100px;
                  font-family: 'fangsong_GB2312';
                  font-size: 20px;
                "
                :style="{
                  borderBottom:
                    index == detail.agendaList.length - 1
                      ? '1px solid black'
                      : '',
                }"
              >
                {{ getReportDeptName(item) }}
              </td>
              <!-- 汇报人 -->
              <td
                style="
                  border-top: 1px solid black;
                  border-right: 1px solid black;
                  padding: 12px;
                  text-align: left;
                  width: 100px;
                  font-family: 'fangsong_GB2312';
                  font-size: 20px;
                "
                :style="{
                  borderBottom:
                    index == detail.agendaList.length - 1
                      ? '1px solid black'
                      : '',
                }"
              >
                {{ getReportPersonName(item) }}
              </td>
              <!-- 参会部门 -->
              <td
                style="
                  border-top: 1px solid black;
                  border-right: 1px solid black;
                  padding: 12px;
                  width: 180px;
                  font-family: 'fangsong_GB2312';
                  font-size: 20px;
                "
                :style="{
                  borderBottom:
                    index == detail.agendaList.length - 1
                      ? '1px solid black'
                      : '',
                }"
              >
                {{ getDepart(item) }}
              </td>
            </tr>
            <tr v-else :key="index">
              <td
                style="
                 
                  border-left: 1px solid black;
                  border-right: 1px solid black;
                  border-bottom: 1px solid black;
                  vertical-align: middle;
                  width: 100px;
                  text-align: center;
                  box-sizing: border-box;
                  padding: 12px;
                  font-family:SimHei;
                  font-size: 20px;
                "
              >
               {{ index + 1 }}
              </td>

              <!-- 会议研究事项 -->
              <td
                colspan="2"
                style="
                  border-top: 1px solid black;
                  border-right: 1px solid black;
                  padding: 12px;
                  width: 200px;
                  font-family: 'fangsong_GB2312';
                  font-size: 20px;
                   text-align:left;
                "
                :style="{
                  borderBottom:
                    index == detail.agendaList.length - 1
                      ? '1px solid black'
                      : '',
                }"
              >
                {{ item.title }}
              </td>
              <!-- 汇报部门 -->
              <td
                style="
                  border-top: 1px solid black;
                  border-right: 1px solid black;
                  padding: 12px;
                  text-align: left;
                  width: 100px;
                  font-family: 'fangsong_GB2312';
                  font-size: 20px;
                "
                :style="{
                  borderBottom:
                    index == detail.agendaList.length - 1
                      ? '1px solid black'
                      : '',
                }"
              >
                {{ getReportDeptName(item) }}
              </td>
              <!-- 汇报人 -->
              <td
                style="
                  border-top: 1px solid black;
                  border-right: 1px solid black;
                  padding: 12px;
                  text-align: left;
                  width: 100px;
                  font-family: 'fangsong_GB2312';
                  font-size: 20px;
                "
                :style="{
                  borderBottom:
                    index == detail.agendaList.length - 1
                      ? '1px solid black'
                      : '',
                }"
              >
                {{ getReportPersonName(item) }}
              </td>
              <!-- 参会部门 -->
              <td
                style="
                  border-top: 1px solid black;
                  border-right: 1px solid black;
                  padding: 12px;
                  width: 150px;
                  font-family: 'fangsong_GB2312';
                  font-size: 20px;
                "
                :style="{
                  borderBottom:
                    index == detail.agendaList.length - 1
                      ? '1px solid black'
                      : '',
                }"
              >
                {{ getDepart(item) }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    </div>
    <div class="printWrap" v-show="false">
        <div
          v-html="meetingPrintContent"
          class="mainHtml"
          id="printmeetingPrintContent"
        ></div>
      </div>
      <el-button
        type="primary"
        @click="PrintContract"
        style="margin: 10px 0"
        >打印
      </el-button>
  </div>
  
</template>

<script>
import printJS from "print-js";
export default {
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
  data(){
    return{
       meetingPrintContent: null,
    }
  },
   mounted() {
    this.meetingPrintContent =
      this.$refs.printContent.innerHTML;
    this.meetingPrintContent = document.getElementById(
      "printContent"
    ).innerHTML;
  },
  methods: {
    //打印当前合同
    PrintContract() {
      this.$set(
        this,
        "meetingPrintContent",
        this.$refs.printContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printmeetingPrintContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
    getReportPersonName(data) {
      let result = [];
      data.declarationList.forEach((item) => {
        let name = item.reportUserName;
        if (result.indexOf(name) == -1) {
          result.push(name);
        }
      });
      return result.join("、");
    },
    getReportDeptName(data) {
      let result = [];
      data.declarationList.forEach((item) => {
        let name = item.deptName;
        if (result.indexOf(name) == -1) {
          result.push(name);
        }
      });
      return result.join("、");
    },
    getDepart(data) {
      let result = new Set();
      data.declarationList.forEach((o) => {
        let checkWorkJson = o.checkWorkJson;
        checkWorkJson = JSON.parse(checkWorkJson);
        checkWorkJson.forEach((c) => {
          result.add(c.name);
        });
      });
      let res = Array.from(result);
      return res.join("、");
    },
  },
  computed: {
    tableTitle: function () {
      return this.detail.typeDisplayName || "";
    },
    topTitle: function () {
      // 中共青岛路桥建设集团有限公司委员会
      return this.detail.printTitle;
    },
    timeStr: function () {
      if (this.detail.startTime) {
        let startTime = this.detail.startTime;
        let startDate = new Date(startTime);
        let year = startDate.getFullYear();
        let month = startDate.getMonth() + 1;
        let date = startDate.getDate();
        let week=startDate.getDay();
        let weeksDic=["日","一","二","三","四","五","六"];
        return `${year}年${month}月${date}日（星期${weeksDic[week]}） ${startDate.toLocaleTimeString()}`;
      }
      console.log("no startTime");
      return "";
    },
    joinWorkPeople: function () {
      try {
        let joinWorkJson = this.detail.joinWorkJson;
        if (joinWorkJson) {
          joinWorkJson = JSON.parse(joinWorkJson);
          let result = joinWorkJson.map((o) => {
            return o.displayName || o.name;
          });
          return result.join("、");
        }
        console.log("no joinWorkJson");
        return "";
      } catch (error) {
        console.log(error);
        return "";
      }
    },
    typeStr: function () {
      return `路桥集团${this.detail.typeDisplayName}`;
    },
  },
  beforeDestroy() {
    console.log("11111-----arrange print dialog destory");
  },
};
</script>

<style></style>
